var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issueSliderBullets"},_vm._l((_vm.pages),function(value ,index){return _c('issue-slider-bullet',{key:index,attrs:{"id":index+1},on:{"handleSliderBullet":_vm._slideTo}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e4e2b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Sunnyfactory/IssueSliderBullets.vue
// module id = null
// module chunks = 